import {
  CustomerBillingModel,
  CustomerLiteModel,
  CustomerModel,
} from 'api-hooks/customer';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { BillingAddressLiteModel } from 'api-hooks/product/sales';
import { transformLabel } from 'common/utils/string';
import useTranslation from 'next-translate/useTranslation';

interface CustomerListTagnameProps {
  customer: CustomerModel | CustomerLiteModel;
}

export function CustomerListTagname(props: CustomerListTagnameProps) {
  const { customer } = props;
  const { t } = useTranslation();
  return (
    <>
      {[
        transformLabel(
          [customer.title && `${t(`enum:${customer.title}`)}`, customer.name],
          ' ',
        ),
        customer.alias,
      ]
        .filter((val) => {
          return !!val;
        })
        .join(' - ') + ` (${customer.phone})`}
    </>
  );
}

interface BillingAddressTagnameProps {
  billingAddress: CustomerBillingModel | BillingAddressLiteModel | null;
}

export function BillingAddressTagname(props: BillingAddressTagnameProps) {
  const { billingAddress } = props;

  if (billingAddress === null) {
    return <>-</>;
  } else {
    return (
      <>
        {[billingAddress.address, billingAddress.phone]
          .filter((val) => !!val)
          .join(' - ')}
      </>
    );
  }
}

interface BookingCodesTagnameProps {
  bookingCodes: (string | null)[];
}

export function BookingCodesTagname(props: BookingCodesTagnameProps) {
  const { bookingCodes } = props;
  const _bookingCodes = bookingCodes.filter((code) => !!code);
  return <>{_bookingCodes.length ? _bookingCodes.join(', ') : '-'}</>;
}

interface EmployeeTagnameProps {
  employee: EmployeeLiteModel | null;
}

export function EmployeeTagname(props: EmployeeTagnameProps) {
  const { employee } = props;

  return <>{employee?.name ?? '-'}</>;
}
